export class GermanUfValuesWindow {
  systemName: string;
  outerFrame: number | null;
  glazingInsulationType: string | null;
  fixedorOperable: string | null;
  glassThickness: number | null;
  papt: string | null;
  uf: number | null;

  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
    this.outerFrame = row['outerFrame'] as number | null;
    this.glazingInsulationType = row['glazingInsulationType'] as string | null;
    this.fixedorOperable = row['fixedorOperable'] as string | null;
    this.glassThickness = row['glassThickness'] as number | null;
    this.papt = row['papt'] as string | null;
    this.uf = row['uf'] as number | null;
  }
}